import * as React from 'react';
import { Carousel } from '@bepure/tarkin';

interface Slide {
    image_url: string;
    alt: string;
}
function getCarouselSlides(carousel: Element): Slide[] {
    const slides = Array.from(carousel.children)
        .map(
            child => Array.from(child.children).reduce((acc, current: any) => {
                acc[current.name] = current.value;
                return acc;
            }, {} as Slide),
        );
    return slides;
}

function getCarouselComponent(carousel: Element): JSX.Element {
    const slides = getCarouselSlides(carousel);
    const component = (
        <Carousel
            slides={slides.map(val => ({image: val.image_url, alt: val.alt}))}
        />
    );
    return component;
}

export default getCarouselComponent;
